import { createEntityAdapter, EntityAdapter } from '@ngrx/entity';
import { Action } from '@ngrx/store';

import { Oauth } from '../../modules/common/entities/user/oauth.entity';
import { OauthState } from '../shared-state.interface';
import { OauthAction, OauthActionTypes } from './oauth.actions';

export const oauthAdapter: EntityAdapter<Oauth> = createEntityAdapter<Oauth>({
    selectId: oauth => oauth.stateKey
});

export const emptyOAuthState: OauthState = oauthAdapter.getInitialState();
export const initialOAuthState: OauthState = emptyOAuthState;

export function oauthReducer(state = initialOAuthState, action: Action): OauthState {
    const specificAction: OauthAction = action as OauthAction;

    switch (specificAction.type) {
        case OauthActionTypes.SetOauth:
            oauthAdapter.removeAll(state);
            return oauthAdapter.addOne(specificAction.payload, emptyOAuthState);
        case OauthActionTypes.UnsetOauth:
            return oauthAdapter.removeAll(state);

        default:
            return state;
    }
}
